import '@babel/polyfill'
import 'airbnb-js-shims'
import React from 'react'
import ReactDOM from 'react-dom'
import 'typeface-roboto'
import './index.css'
import App from './containers/App'
// import registerServiceWorker from './registerServiceWorker'

if (!Math.trunc) {
	Math.trunc = function(v) {
		v = +v;
		if (!isFinite(v)) return v;

		return (v - v % 1)   ||   (v < 0 ? -0 : v === 0 ? v : 0);
	};
}

// console.log('0.9.131')

ReactDOM.render(<App />, document.getElementById('root'))
if (module.hot) {
  module.hot.accept('./containers/App', () => {
    ReactDOM.render(<App />, document.getElementById('root'))
  })
}
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js